import { type FC, useEffect } from "react";
import FontAwesomeLight from "../../../Utilities/Platform/FontAwesome/FontAwesomeLight";
import { MEDIA_FILE_PAGE_SIZE } from "./MediaUtilities";

interface Props {
    index: number;
    onLoad: (index: number) => void;
}

export const FileLoading: FC<Props> = ({ index, onLoad }) => {
    useEffect(() => {
        onLoad(Math.trunc(index / MEDIA_FILE_PAGE_SIZE));
    }, [ index, onLoad ]);

    return (
        <div className="file loading">
            <div className="media-thumbnail">
                <FontAwesomeLight icon="spinner-third" spin />
            </div>
            <div className="media-details">
                Loading...
            </div>
        </div>
    );
};
